import { render, staticRenderFns } from "./ShopUploadTemplate.vue?vue&type=template&id=5f89875b&"
import script from "./ShopUploadTemplate.vue?vue&type=script&lang=js&"
export * from "./ShopUploadTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports